(function () {
  const AUTOPLAY_MS = 4500;
  const MOBILE_MAX = 749;
  const READY_CLASS = 'oum-benefits-carousel--ready';

  function initSection(section) {
    if (section.dataset.oumBenefitsInit === 'true') return;
    section.dataset.oumBenefitsInit = 'true';

    const track = section.querySelector('.section-content-wrapper');
    if (!track) return;

    let timer = null;
    let index = 0;
    let layoutSettled = false;

    const getSlides = () => Array.from(track.querySelectorAll(':scope > .group-block'));

    const isMobile = () => window.innerWidth <= MOBILE_MAX;

    const resetToStart = () => {
      index = 0;
      const previousInlineBehavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollTo({ left: 0, behavior: 'auto' });
      requestAnimationFrame(() => {
        track.style.scrollBehavior = previousInlineBehavior;
      });
    };

    const forceStartAtFirstSlide = () => {
      resetToStart();
      requestAnimationFrame(() => {
        resetToStart();
      });
    };

    const scrollToIndex = (nextIndex, instant = false) => {
      const slides = getSlides();
      if (!slides.length) return;

      index = ((nextIndex % slides.length) + slides.length) % slides.length;
      const targetSlide = slides[index];
      const left = targetSlide?.offsetLeft ?? 0;

      if (instant) {
        track.scrollLeft = left;
        return;
      }

      track.scrollTo({ left, behavior: 'smooth' });
    };

    const startAutoplay = () => {
      if (!isMobile() || timer) return;
      timer = window.setInterval(() => scrollToIndex(index + 1), AUTOPLAY_MS);
    };

    const stopAutoplay = () => {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    };

    const prepareCarousel = () => {
      if (!isMobile()) {
        track.classList.remove(READY_CLASS);
        stopAutoplay();
        return;
      }

      forceStartAtFirstSlide();
      track.classList.add(READY_CLASS);
      stopAutoplay();
      startAutoplay();
    };

    const whenLayoutReady = (fn) => {
      requestAnimationFrame(() => requestAnimationFrame(fn));
    };

    whenLayoutReady(prepareCarousel);

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(() => {
        if (!isMobile()) return;

        if (!layoutSettled) {
          forceStartAtFirstSlide();
          track.classList.add(READY_CLASS);
          layoutSettled = true;
          return;
        }

        scrollToIndex(index, true);
      });
      observer.observe(track);
    }

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => {
        if (isMobile()) forceStartAtFirstSlide();
      });
    }

    track.addEventListener('pointerdown', stopAutoplay, { passive: true });
    track.addEventListener('touchstart', stopAutoplay, { passive: true });
    window.addEventListener('pageshow', () => {
      if (!isMobile()) return;
      forceStartAtFirstSlide();
      stopAutoplay();
      startAutoplay();
    });

    window.addEventListener('resize', () => whenLayoutReady(prepareCarousel));
  }

  function boot() {
    document.querySelectorAll('.shopify-section:has(.oum-benefits-carousel-hook)').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
